module.exports = "/images/screen@2x.png?013745ed0cfa46776bed7c8cdadcc671";